import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';

export const THUMBNAIL_WIDTH = '5.625rem';
export const THUMBNAIL_HEIGHT = '3.75rem';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  ${getTypography(theme, TypographyName.BODY)}
  text-align: left;

  color: ${theme.palettes.brand.primary};
  cursor: pointer;

  a {
    text-decoration: none;
  }
`;

export const thumbnail: ThemedFunctor = ({
  theme,
}) => css`
  min-width: ${THUMBNAIL_WIDTH};
  min-height: ${THUMBNAIL_HEIGHT};
  width: ${THUMBNAIL_WIDTH};
  height: ${THUMBNAIL_HEIGHT};
  ${getSpacing.marginRight(theme, SpacingName.SMALLER)}
  background-color: ${theme.palettes.neutrals.lighter};

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  flex-grow: 1;
  ${getSpacing.paddingLeft(theme, SpacingName.SMALLEST)}
  line-height: 1.4;
`;

export const details: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.medium};
  margin-top: .25rem;
`;
